import type { BoardView } from '../boardMVC/views/board/BoardView';
import { BoardFireworksAnimationLayout } from '../../../layouts/scoring/BoardFireworksAnimationLayout';
import { playLayoutAnimation } from '../../libs/layouts/layoutAnimations/playLayoutAnimation';

export async function startLevelEndAnimation(boardView: BoardView): Promise<void> {
  boardView.tweenTo({ y: boardView.y + 100 }, 1000, 'sinIn', true);
  const bounds = boardView.getBounds();
  const fireworksLayout = new BoardFireworksAnimationLayout();
  fireworksLayout.root.props({
    parent: boardView.parent,
    x: boardView.x + bounds.width * 0.5,
    y: boardView.y + bounds.height * 0.4,
  });
  await playLayoutAnimation(fireworksLayout, 'Fireworks', false);
}
